import React, { useEffect, useState } from 'react'
import { readMedicalProfessionalUsers } from '../Admin/medical-professionals/utils/utils'
import EHRCalendar from './full-calendar'
import { message, Divider, Typography, Space, Row, Col, theme } from 'antd'
import { handleError } from '../lib/utils'
import { isAdmin, userClinics } from '../lib/profile-utils'
import { FullCalendarEnums } from './full-calendar-utils/full-calendar-enums'
import { useSelector } from 'react-redux'
import CalendarLoadPlaceholder from './calendar-load-placeholder'
import { ContainerCard } from '../reusable-components/AgiliteCards'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'
import PageHeader from '../reusable-components/PageHeader'

const { Title, Text } = Typography

const FullCalendarWrapper = () => {
  // REDUX STATES
  const clinicsState = useSelector((state) => state.clinics.data)
  const { token } = theme.useToken()

  // USESTATES
  const [professionalsListed, setProfessionalsListed] = useState([])
  const [medProfsOnDuty, setMedProfsOnDuty] = useState([])

  // NEW STATES
  const [medicalProfessionalsLoading, setMedicalProfessionalsLoading] = useState(true)
  const [currentView, setCurrentView] = useState(FullCalendarEnums.viewTypeKeys.DAY_VIEW)
  const [currentDate, setCurrentDate] = useState(new Date())

  useEffect(() => {
    fetchMedicalProfessionals()
    // eslint-disable-next-line
  }, [])

  const fetchMedicalProfessionals = async () => {
    setMedicalProfessionalsLoading(true)
    try {
      let qry = {}
      // Build query based on admin status
      if (isAdmin()) {
        qry = {
          'extraData.clinics': { $in: clinicsState.map((clinic) => clinic._id) },
          'extraData.isActive': true // Add isActive check
        }
      } else {
        qry = {
          'extraData.clinics': { $in: userClinics() },
          'extraData.isActive': true // Add isActive check
        }
      }

      // Fetch medical professionals
      const tmpListedProfessionals = await readMedicalProfessionalUsers(qry)
      setProfessionalsListed(tmpListedProfessionals)

      // We don't need to pre-filter medProfsOnDuty anymore since
      // availability is now tied directly to the medical professional
      setMedProfsOnDuty([])
    } catch (e) {
      message.error(handleError(e))
    }
    setMedicalProfessionalsLoading(false)
  }

  return (
    <ContainerCard bodyStyle={{ padding: 0, overflow: 'hidden' }}>
      <div>
        <PageHeader title='Appointments Calendar' icon={faCalendarCheck} />

        <div style={{}}>
          {medicalProfessionalsLoading ? (
            <CalendarLoadPlaceholder
              medicalProfessionalsLoading={medicalProfessionalsLoading}
              medicalProfessionals={professionalsListed}
              medProfsOnDuty={medProfsOnDuty}
              currentView={currentView}
              setCurrentView={setCurrentView}
              currentDate={currentDate}
              setCurrentDate={setCurrentDate}
            />
          ) : (
            <EHRCalendar
              medicalProfessionalsLoading={medicalProfessionalsLoading}
              medicalProfessionals={professionalsListed}
              medProfsOnDuty={medProfsOnDuty}
              currentView={currentView}
              setCurrentView={setCurrentView}
              currentDate={currentDate}
              setCurrentDate={setCurrentDate}
            />
          )}
        </div>
      </div>
    </ContainerCard>
  )
}

export default FullCalendarWrapper
